import pl from './pl'
import en from './en'

export default function Translate(str) {
    let lang = localStorage.getItem("i18nextLng")?localStorage.getItem("i18nextLng"):"en"; //en is base lang
    let translate;

    if(!lang) {
        localStorage.setItem("i18nextLng","pl")
        translate = pl
    } else {
        if(lang=="pl") {
            translate = pl
        }else if(lang=="en") {
            translate = en
        }
    }
    
    return translate[str];
}